import React from 'react';
import {type TFunction} from 'i18next';

type Context = {
  appName: string;
  useMessage: TFunction<'translation', undefined>;
};

const EzManageNavContext = React.createContext<Context>({
  appName: 'OTHER',
  useMessage: (() => '') as any,
});

export default EzManageNavContext;
